/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */

import React, { useEffect, useRef, useState } from 'react'
import MainLayout from '../Layouts/Mainlayout'
import OutlineButton from '../MUICustomButton/OutlineButton'
//@ts-ignore
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Autocomplete, FormControl, Grid, InputAdornment, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailSend02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ChartLineData02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { Chart01Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailOpen02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailRemove02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailBlock02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { Cursor02Icon, TimeScheduleStrokeRounded, Download04Icon  } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { SentStrokeStandard } from '@hugeicons-pro/core-stroke-standard';
import moment from 'moment';
import LineChartComponent from './LineChartComponent';
import BarGraphComponent from './BarGraphComponent';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
//@ts-ignore
import HeatMap from "react-heatmap-grid";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getCampaignReportCardCounts, getCampaignReportData, getCampaignReportDeviceCount, getCampaignReportDomainCount } from 'src/services/campaignService';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
import { styled } from '@mui/material/styles';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import CsvService from 'src/services/dataExport.service';
// @ts-ignore
import { NotificationManager } from 'react-notifications';
//@ts-ignore
import { UserIcon } from '@hugeicons-pro/core-stroke-sharp';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
    [`& .${tooltipClasses.arrow}`]: {
        display: 'none',
    },
}));

const xLabels = new Array(24).fill(0).map((_, i) => `${i}`);

// Display only even labels
const xLabelsVisibility = new Array(24)
    .fill(0)
    .map((_, i) => (i % 2 === 0 ? true : true));

const inputLabels: any = [
    { key: "emailSent", label: "Sent", color: "#3FCEE1" },
    { key: "opens", label: "Opens", color: "#5FD242" },
    { key: "clicks", label: "Clicks", color: "#4B8DF5" },
    { key: "unsubscribes", label: "Unsubscribes", color: "#3A3A3A" },
    { key: "complaints", label: "Complaints", color: "#F95050" }
];

function ViewCampaignReports(): JSX.Element {

    const location = useLocation(); // Get the location object
    const { state } = location || {}; // Extract state from location
    const { start, end, campaignName, brandName, groupName } = state || {}; // Destructure startDate and endDate

    const [fromDate, setFromDate] = useState<any>(start)
    const [endDate, setEndDate] = useState<any>(end)
    const [dashboardDateRange, setDashboardDateRange] = useState<any>()
    const [graphData, setGraphData] = useState<any>([]);
    const [cardData, setCardData] = useState<any>([])
    const [isDateRangeOpen, setIsDateRangeOpen] = useState<boolean>(false)
    const [alignment, setAlignment] = useState<string>('line');
    const [width, setWidth] = useState<number>(0);
    const [isCardDataLoading, setIsCardDataLoading] = useState<boolean>(false)
    const [isDomainDataLoading, setIsDomainDataLoading] = useState<boolean>(false)
    const [domainCount, setDomainCount] = useState<any>([]);
    const [heatmapData, setHeatmapData] = useState<any>([]);
    const [deviceCount, setDeviceCount] = useState<any>([]);
    const [emailClientCount, setEmailClientCount] = useState<any>([]);
    const [clickByURLCount, setClickByURLCount] = useState<any>([]);
    const [isEmailDataLoading, setIsEmailDataLoading] = useState<boolean>(false)
    const [yLabels, setYLabels] = useState<any>([]);
    const [selectedStatus, setSelectedStatus] = useState<any>({ id: 0, label: "Initial Send" });

    const dateRangeRef: any = useRef(null);
    const containerRef = useRef<HTMLDivElement | null>(null);

    const { user } = useSelector((state: RootState) => state.auth);
    const param = useParams();

    const { id } = param;



    const navigate = useNavigate()

    useEffect(() => {
        const currentDates = getLast7Days();
        setFromDate(start)
        setEndDate(end)

        const resize = (): void => {
            if (containerRef.current) {
                setWidth(containerRef.current.offsetWidth);
            }
        };

        resize(); // Set on mount

        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: any): void => {
            if (dateRangeRef.current && !dateRangeRef.current.contains(event.target)) {
                setIsDateRangeOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        getCardCountData()
        getDomainCountData()
        getEmailCountData()
    }, [user, fromDate, endDate, id, selectedStatus])

    const getCardCountData = (): void => {
        setIsCardDataLoading(true)
        const ClientId = user?.clientId ?? 0;
        const startDate = moment(fromDate).format("YYYY-MM-DD")
        const endDateFormatted = moment(endDate).format("YYYY-MM-DD")
        const status = selectedStatus.id
        getCampaignReportCardCounts(id, ClientId, startDate, endDateFormatted, status).then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    const dataset: any = [];
                    res.data.data.chartCounts.map((data: any) => {
                        dataset.push({
                            date: moment(new Date(data.day)).format("MMM DD"),
                            emailSent: data.sends,
                            opens: data.opens,
                            clicks: data.clicks,
                            unsubscribes: data.unSubscribes,
                            complaints: data.complaints
                        })
                    })
                    setGraphData(dataset)
                    setCardData(res.data.data.cardCounts)
                }

            }
        }).catch(
            (error: any) => console.log("Error: ", error)
        )
            .finally(
                () => setIsCardDataLoading(false)
            )
    }

    const getDomainCountData = (): void => {
        setIsDomainDataLoading(true)
        const ClientId = user?.clientId ?? 0;
        const startDate = moment(fromDate).format("YYYY-MM-DD")
        const endDateFormatted = moment(endDate).format("YYYY-MM-DD")
        const status = selectedStatus.id
        getCampaignReportDomainCount(id, ClientId, startDate, endDateFormatted, status).then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    setDomainCount(res.data.data.domainSummary)

                    // const yLabelArr = [];
                    const hData = res.data.data.heatmapData;

                    if (hData.length > 0) {
                        // Extract Y-axis labels (dates)
                        const yLabels = hData.map((data: any) => data.dayofweek.substring(0, 3));

                        // Prepare heatmap matrix
                        const heatmapMatrix = hData.map((data: any) => {
                            const hourCounts = data.hourCounts;
                            return Object.keys(hourCounts).map((hour) => hourCounts[hour]);
                        });

                        setYLabels(yLabels); // Set Y-axis labels
                        setHeatmapData(heatmapMatrix); // Set heatmap matrix
                    }
                }

            }
        }).catch(
            (error: any) => console.log("Error: ", error)
        )
            .finally(
                () => setIsDomainDataLoading(false)
            )
    }

    const getEmailCountData = (): void => {
        setIsEmailDataLoading(true)
        const ClientId = user?.clientId ?? 0;
        const startDate = moment(fromDate).format("YYYY-MM-DD")
        const endDateFormatted = moment(endDate).format("YYYY-MM-DD")
        const status = selectedStatus.id
        getCampaignReportDeviceCount(id, ClientId, startDate, endDateFormatted, status).then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    setDeviceCount(res.data.data.deviceMtrcCounts)
                    setEmailClientCount(res.data.data.clientMtrPercentage)
                    setClickByURLCount(res.data.data.clicksByURL)
                }

            }
        }).catch(
            (error: any) => console.log("Error: ", error)
        )
            .finally(
                () => setIsEmailDataLoading(false)
            )
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars


    const handleDateChange = (): void => {
        setIsDateRangeOpen(true)
        // const currentDates = getLast7Days();
        setDashboardDateRange({
            startDate: fromDate,
            endDate: endDate,
            key: 'selection'
        })

        // setFromDate(currentDates.startDate)
        // setEndDate(currentDates.endDate)
    }

    const getLast7Days = (): any => {
        const now = new Date();
        const endDate = new Date(now); // Today
        const startDate = new Date();
        startDate.setDate(now.getDate() - 6); // Go back 6 days (including today, makes 7 days)

        return {
            startDate,
            endDate
        };
    };

    const handleDateRangeClick = (ranges: any): void => {
        console.log(ranges)
        setDashboardDateRange(
            {
                startDate: ranges.selection.startDate,
                endDate: dashboardDateRange.endDate && dashboardDateRange.endDate > ranges.selection.startDate ? ranges.selection.endDate !== dashboardDateRange.endDate && ranges.selection.endDate !== ranges.selection.startDate ? ranges.selection.endDate : dashboardDateRange.endDate : ranges.selection.endDate,
                key: "selection"
            }
        )



        if (ranges.selection.startDate !== ranges.selection.endDate) {
            // setIsDateRangeOpen(false)
            setFromDate(ranges.selection.startDate)
            setEndDate(ranges.selection.endDate)

            setTimeout(() => {
                setIsDateRangeOpen(false);

            }, 5000); // slight delay for UX

        }
    }

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ): void => {
        setAlignment(newAlignment);
    };

    const control = {
        value: alignment,
        onChange: handleChange,
        exclusive: true,
    };

    const today = new Date();
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(today.getDate() - 90);

    const handleBackClick = (): void => {
        navigate(`/campaigns`);
    }

    const handleExportReport = (): void => {
        const start = moment(fromDate).format("MM/DD/YYYY")
        const end = moment(endDate).format("MM/DD/YYYY")
        getCampaignReportData(id, start, end)
            .then((res: any) => {
                if (res.status === 200) {
                    console.log(res)
                    if (res.data.result === 1) {
                        const reportData = res.data.data;

                        const data: any = [];
                        if (reportData.length > 0) {

                            reportData.map((item: any) => {
                                const newItem = {
                                    "Campaign Id": item.campaignId,
                                    "Event Id": item.eventId,
                                    "Event Type": item.eventType,
                                    "Event Time": moment(item.eventTime).format("MM-DD-YYYY hh:mm:ss") ,
                                    "Event Data": item.eventData,
                                    "NPI": item.npi,
                                    "Template Id": item.templateId,
                                    "From Name": item.fromName,
                                    "Brand": item.brand,
                                    "Request Id": item.requestId,
                                }

                                data.push(newItem)
                            })

                            const csvData = CsvService.jsonToCsv(data);
                            CsvService.downloadCsvFile(csvData, 'CampaignReport.csv');
                        } else {
                            NotificationManager.error('No data available for download', '', 5000);
                        }
                    } else {
                        NotificationManager.error('No data available for download', '', 5000);
                    }
                }
            })
    }

    const domainColumns = [
        {
            name: 'Domain',
            selector: (row: any) => row.domainName,
            // width: '20%',
            cell: (row: any) => {
                return (
                    <BootstrapTooltip title={row.domainName}>
                        <div className='text-muted text-14'>{row.domainName && row.domainName.length > 10 ? `${row.domainName.substring(0, 10)}...` : row.domainName}</div>
                    </BootstrapTooltip>
                )
            }
        },
        {
            name: '% Usings',
            selector: (row: any) => row.percentageUsage,
            cell: (row: any) => {
                return (
                    <div className='flext flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.percentageUsage}%</div>
                        {/* <div className="table-error">-2%</div> */}
                    </div>
                )
            }
        },
        {
            name: 'Delivery Rate',
            selector: (row: any) => row.deliveryRate,
            cell: (row: any) => {
                return (
                    <div className='flext flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.deliveryRate}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            }
        },
        // {
        //     name: 'Bounce Rate',
        //     selector: (row: any) => row.clicks,
        //     cell: (row: any) => {
        //         return (
        //             <div className='flext flex-col gap-x-[5px] text-right'>
        //                 <div className='text-muted text-14 table-count-data'>{row.clicks}%</div>
        //                 <div className="table-error">-2%</div>
        //             </div>
        //         )
        //     }
        // },
        {
            name: 'Open Rate',
            selector: (row: any) => row.openRate,
            cell: (row: any) => {
                return (
                    <div className='flext flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.openRate}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            }
        },
        {
            name: 'Click Rate',
            selector: (row: any) => row.clickRate,
            cell: (row: any) => {
                return (
                    <div className='flext flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.clickRate}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            }

        },
    ]

    const deviceColumns = [
        {
            name: 'Device Type',
            selector: (row: any) => row.emailDeviceType,
            width: '35%'
        },
        {
            name: '% Usings',
            selector: (row: any) => row.percentageUsage,
            cell: (row: any) => {
                return (
                    <div className='flext flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.percentageUsage}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            }
        },
        {
            name: 'Open Rate',
            selector: (row: any) => row.openRate,
            cell: (row: any) => {
                return (
                    <div className='flext flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.openRate}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            }
        },
        {
            name: 'Click Rate',
            selector: (row: any) => row.clickRate,
            cell: (row: any) => {
                return (
                    <div className='flext flex-col gap-x-[5px] text-right'>
                        <div className='text-muted text-14 table-count-data'>{row.clickRate}%</div>
                        {/* <div className="table-success">+2%</div> */}
                    </div>
                )
            }
        },
    ]

    const clickColumns = [
        {
            name: 'URL',
            selector: (row: any) => row.url,
            width: '50%',
            cell: (row: any) => {
                return (
                    <BootstrapTooltip title={row.url}>
                        <div className='text-muted text-14'>{row.url && row.url.length > 50 ? `${row.url.substring(0, 50)}...` : row.url}</div>
                    </BootstrapTooltip>
                )
            }
        },
        {
            name: 'Sent',
            selector: (row: any) => row.sends,
            // width: '15%'
        },
        // {
        //     name: 'Delivered',
        //     selector: (row: any) => row.delivered,
        // },
        {
            name: 'Open',
            selector: (row: any) => row.opens,
            // width: '15%'
        },
        {
            name: 'Click',
            selector: (row: any) => row.clicks,
            // width: '15%'
        },
    ]

    const statusArr = [
        { id: 0, label: "Initial Send" },
        { id: 1, label: "First Resend" },
        { id: 2, label: "Second Resend" },
    ]

    return (
        <div className="flex flex-row justify-start">
            <MainLayout>
                <div className="flex justify-between items-center mb-[20px]">
                    <div className='flex gap-x-[30px]'>
                        <h1 className="text-2xl text-title font-semibold">Campaign ID: {id}</h1>

                        <div>
                            <FormControl fullWidth>
                                <Autocomplete
                                    options={statusArr}
                                    getOptionLabel={(option) => option.label}
                                    popupIcon={
                                        <HugeiconsIcon
                                            icon={ArrowDown01Icon}
                                            size={18}
                                            color="#3A3A3A"
                                            strokeWidth={0.2}

                                        />
                                    }
                                    onChange={(event, newValue) => {
                                        setSelectedStatus(newValue);
                                        console.log("Selected status: ", newValue)
                                    }}
                                    value={selectedStatus}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Status"
                                            variant="outlined"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '40px',
                                                    height: '40px',
                                                    width: '200px', // Increased width
                                                },
                                            }}
                                        />
                                    )}
                                    sx={{
                                        '& .MuiAutocomplete-clearIndicator': {
                                            marginRight: '-12px'
                                        },
                                        '& .MuiAutocomplete-input': {
                                            width: '70%'
                                        }
                                    }}

                                />
                            </FormControl>
                        </div>
                        <div >
                            <FormControl className='form-dropdown' fullWidth>
                                <TextField
                                    id="date-range"
                                    label="Date Range"
                                    variant="outlined"
                                    autoComplete='off'
                                    ref={dateRangeRef}
                                    fullWidth
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                                            <HugeiconsIcon
                                                icon={Calendar03Icon}
                                                size={18}
                                                color="#3A3A3A"
                                                strokeWidth={0.5}
                                                onClick={handleDateChange}
                                            />
                                        </InputAdornment>
                                    }}
                                    onChange={handleDateChange}
                                    onFocus={handleDateChange}
                                    // onBlur={() => setIsLastActivityOpen(false)}
                                    value={fromDate && endDate ? `${moment(fromDate).format('MM/DD/YYYY')} - ${moment(endDate).format('MM/DD/YYYY')}` : ""}
                                />
                            </FormControl>
                            {isDateRangeOpen && (
                                <div ref={dateRangeRef} style={{ position: 'absolute', zIndex: '999' }}>
                                    <DateRangePicker
                                        ranges={[dashboardDateRange]}
                                        onChange={handleDateRangeClick}
                                        dateDisplayFormat={'MM/dd/yyyy'}
                                        inputRanges={[]}
                                        color={"#FFF5F6"}
                                        rangeColors={["#D6242C"]}
                                        editableDateInputs={true}
                                        startDatePlaceholder={"MM/DD/YYYY"}
                                        endDatePlaceholder={"MM/DD/YYYY"}
                                        minDate={ninetyDaysAgo}
                                        maxDate={today}
                                    />
                                </div>
                            )}
                        </div>
                        <div>
                            <OutlineButton onClick={handleExportReport} type='rounded' color='gray' width='140px'>
                            <HugeiconsIcon
                                icon={Download04Icon}
                                size={20}
                                color="#3a3a3a"
                                stroke='0.2'
                            />
                                <span className='ml-[5px]'>Download</span>
                            </OutlineButton>
                        </div>
                    </div>
                    <div>
                        <OutlineButton onClick={handleBackClick} type='rounded' color='red' width='180px'>
                            <img src="/assets/images/red-arrow.svg" alt="arrow" width={9} height={8} className="mr-[5px] mt-[1px]" />
                            Campaign Overview
                        </OutlineButton>
                    </div>
                </div>
                <div className="flex gap-x-[30px] items-center mb-[20px]">
                    <div className="text-14 text-muted">
                        <span className='font-semibold'>Campaign Name:</span> {campaignName}
                    </div>
                    <div className="text-14 text-muted">
                        <span className='font-semibold'>Campaign Start:</span> {start}
                    </div>
                    <div className="text-14 text-muted">
                        <span className='font-semibold'>Campaign End:</span> {end}
                    </div>
                    <div className="text-14 text-muted">
                        <span className='font-semibold'>Brand:</span> {brandName ? brandName : 'Unavailable'}
                    </div>
                    <div className="text-14 text-muted">
                        <span className='font-semibold'>Group:</span> {groupName ? groupName : 'Unavailable'}
                    </div>

                </div>
                
                <div className='mb-[20px]'>
                    <Grid container spacing={2} columns={14}>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Total NPI</div>
                                <div className='box-count'>
                                    <div className='count'>{cardData.totalNPI}</div>
                                    <div className='icon bg-[#EDEDFF]'>
                                        <HugeiconsIcon
                                            icon={UserIcon}
                                            size={24}
                                            color="#6B6BFB"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Sent</div>
                                <div className='box-count'>
                                    <div className='count'>{cardData.totalSends}</div>
                                    <div className='icon bg-[#DBF7FB]'>
                                        <HugeiconsIcon
                                            icon={MailSend02Icon}
                                            size={24}
                                            color="#3FCEE1"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Opens</div>
                                <div className='box-count'>
                                    <div className='count'>{cardData.totalOpens}</div>
                                    <div className='icon bg-[#DBF6D4]'>
                                        <HugeiconsIcon
                                            icon={MailOpen02Icon}
                                            size={24}
                                            color="#5FD242"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Clicks</div>
                                <div className='box-count'>
                                    <div className='count'>{cardData.totalClicks}</div>
                                    <div className='icon bg-[#E0ECFF]'>
                                        <HugeiconsIcon
                                            icon={Cursor02Icon}
                                            size={24}
                                            color="#4B8DF5"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Click-to-Open</div>
                                <div className='box-count'>
                                    <div className='count'>{cardData.totalClickToOpenRate}</div>
                                    <div className='icon bg-[#EDEDFF]'>
                                        <HugeiconsIcon
                                            icon={TimeScheduleStrokeRounded}
                                            size={24}
                                            color="#183FF7"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Unsubscribes</div>
                                <div className='box-count'>
                                    <div className='count'>{cardData.totalUnSubscribes}</div>
                                    <div className='icon bg-[#F0F0F2]'>
                                        <HugeiconsIcon
                                            icon={MailRemove02Icon}
                                            size={24}
                                            color="#3A3A3A"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className='box-container'>
                                <div className='title'>Complaints</div>
                                <div className='box-count'>
                                    <div className='count'>{cardData.totalComplaints}</div>
                                    <div className='icon bg-[#FEDADA]'>
                                        <HugeiconsIcon
                                            icon={MailBlock02Icon}
                                            size={24}
                                            color="#F95050"
                                            strokeWidth={0.2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>

                    </Grid>
                </div>

                <div className='mb-[20px]'>
                    <Grid container spacing={2}>
                        <Grid item xs={7}>
                            <div style={{ height: "400px", }} className='graph-container reports-graph-container'>
                                <div className='flex justify-between items-center relative mb-[25px] right-[30px]'>
                                    <div className='text-[18px] font-semibold text-muted mb-5 ml-[29px]'>Sending overview</div>
                                    <div>
                                        <ToggleButtonGroup size="medium" {...control} aria-label="Medium sizes">
                                            <ToggleButton value="line" aria-label="line">
                                                <HugeiconsIcon
                                                    icon={ChartLineData02Icon}
                                                    size={18}
                                                    color="#3A3A3A"
                                                    strokeWidth={0.2}
                                                />
                                            </ToggleButton>
                                            <ToggleButton value="bar" aria-label="bar">
                                                <HugeiconsIcon
                                                    icon={Chart01Icon}
                                                    size={18}
                                                    color="#3A3A3A"
                                                    strokeWidth={0.2}
                                                />
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>
                                </div>
                                <React.Fragment>
                                    {
                                        isCardDataLoading ? <div className='flex justify-center items-center relative top-[40%]'><span className="loading loading-spinner text-primary"></span></div> :
                                            <React.Fragment>
                                                {
                                                    alignment === 'line' ? <LineChartComponent dataset={graphData} labels={inputLabels} /> : <BarGraphComponent dataset={graphData} labels={inputLabels} />
                                                }
                                            </React.Fragment>
                                    }

                                </React.Fragment>

                            </div>
                        </Grid>
                        <Grid item xs={5}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[400px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Email Domains</div>
                                <div className='click-url-table email-domain'>
                                <CustomDataTable
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                    columns={domainColumns}
                                    data={domainCount}
                                    // pagination
                                    progressPending={isDomainDataLoading}
                                />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>

                <div >
                    <Grid container spacing={2}>
                        <Grid item xs={7}>
                            <div className='graph-container mb-[20px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Send time heatmap</div>
                                {
                                    isDomainDataLoading ? <div className='flex justify-center items-center relative top-[40%]'><span className="loading loading-spinner text-primary"></span></div> :
                                        <div ref={containerRef} className="heatmap-container">
                                            <HeatMap
                                                xLabels={xLabels}
                                                yLabels={yLabels}
                                                xLabelsLocation={"top"}
                                                xLabelsVisibility={xLabelsVisibility}
                                                xLabelWidth={60}
                                                data={heatmapData}
                                                squares
                                                height={45}
                                                // onClick={(x: any, y: any) => alert(`Clicked ${x}, ${y}`)}
                                                cellStyle={(background: any, value: any, min: any, max: any, data: any, x: any, y: any) => ({
                                                    background: `rgb(220, 5,  3, ${1 - (max - value) / (max - min)})`,
                                                    fontSize: "11.5px",
                                                    color: "#333",
                                                })}
                                                cellRender={(value: any) => value && <div>{value}</div>}
                                            />
                                        </div>
                                }

                            </div>
                        </Grid>
                        <Grid item xs={5}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[360px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Devices</div>
                                <div className='click-url-table device'>
                                <CustomDataTable
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                    columns={deviceColumns}
                                    data={deviceCount}
                                    // pagination
                                    progressPending={isEmailDataLoading}
                                />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>


                <div className='mb-[20px]'>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[410px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Clicks by URL</div>
                                <div className='click-url-table'>
                                    <CustomDataTable
                                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                        columns={clickColumns}
                                        data={clickByURLCount}
                                        // pagination
                                        progressPending={isEmailDataLoading}
                                    />
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className='bg-white border border-[#E6ECF2] p-[15px] rounded-[15px] min-h-[410px]'>
                                <div className='text-[18px] font-semibold text-muted mb-5'>Top email clients</div>
                                <div className='h-[330px] overflow-y-auto pr-[15px]'>
                                {
                                    isEmailDataLoading ? <div className='flex justify-center items-center relative top-[40%]'><span className="loading loading-spinner text-primary"></span></div> :
                                        <React.Fragment>
                                            {
                                                emailClientCount.map((client: any, index: any) => {
                                                    return (
                                                        <div key={index} className="flex justify-between items-center mb-[20px]">
                                                            <div className='text-muted text-14'>{client.emailClientName}</div>
                                                            <div className='text-muted text-14 font-bold'>{client.percentage}%</div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </React.Fragment>
                                }
                                </div>
                                {
                                    emailClientCount.length === 0 ? <div className='flex justify-center items-center relative text-muted text-14'>There are no records to display</div> : null
                                }

                            </div>
                        </Grid>
                    </Grid>
                </div>
            </MainLayout>
        </div>

    )
}

export default ViewCampaignReports